import Transaction from './Transaction';

interface BankAccountDetails {
  bankNumber: string;
  bankName: string;
  branchNumber: string;
  accountNumber: string;
  accountOwnerName: string;
}

interface ContactDetails {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

interface TransactionAdditionalInfo {
  contactDetails: ContactDetails;
  bankAccountDetails: BankAccountDetails;
  last4Digits: string;
}

/**
 * Where a row's donor and bank details are read. The Israeli and the US APT number their movements
 * independently, so the id alone points at the Israeli movement of that number - for a dollar row,
 * an unrelated donor's phone and email (SPR-10065). The row's source travels with it, as for its
 * receipt (HAT-1432), and so does its own fund - the board may be showing all funds.
 */
export const transactionAdditionalInfoUrl = (transaction: Pick<Transaction, 'fundId' | 'transactionId' | 'defaultReceipt'>): string =>
  `funds/financial-data/${transaction.fundId}/transactions/${transaction.transactionId}/additional-info?us=${transaction.defaultReceipt === false}`;

export default TransactionAdditionalInfo;
